// function debounce(func, delay) {let timeoutId; return function (...args) {const context = this; clearTimeout(timeoutId);timeoutId = setTimeout(() => { func.apply(context, args) }, delay)}}
// // ------------ Cart Var Edit start -------------------
// function showEditVar(i){
//     let popup = i.querySelector('.ctm_var_edit--popup');
//     popup.classList.add('ctm_var_edit--popup--active');
//     setTimeout(() => { popup.classList.add('ctm_var_edit--popup--active_animation') }, 100);
// }
// function hideEditVar(i = false){
//     let popup = document.querySelector('.ctm_var_edit--popup--active');
//     if(i){ popup = i.querySelector('.ctm_var_edit--popup--active') }
//     popup?.classList.remove('ctm_var_edit--popup--active_animation');
//     setTimeout(() => { popup?.classList.remove('ctm_var_edit--popup--active') }, 250);
// }
// function varChangeStart(item){
//     let i = item.querySelector('.ctm_var_edit--popup_wrapper');
//     let curr_qty = i.getAttribute('data-cart-var-qty');
//     let new_var = i.getAttribute('data-sel-var-id');
//     let updates = {};
//     updates[new_var] = curr_qty;
//     i.querySelector('.ctm_var-edit--loader').classList.add('ctm_var-edit--loader--active');
//     fetch(window.Shopify.routes.root + "cart/update.js", { method: "POST",headers: { "Content-Type": "application/json"},body: JSON.stringify({ updates }) })
//     // .then( () => updateCartDrawerContents() )
//     .then( () => {
//         let cart_qty_btn = item.querySelector('.\\#cart-item-quantity-controls .\\#cart-item-quantity-controls-item');
//         if(cart_qty_btn){ cart_qty_btn.setAttribute('set-value','0'); cart_qty_btn.click(); }
//         else{ let it_em = item.querySelector('.\\#cart-drawer-product-qty-button.\\@type\\:minus'); it_em.setAttribute('set-value','0'); it_em.click(); }
//         hideEditVar(item);
//         i.querySelector('.ctm_var-edit--loader').classList.remove('ctm_var-edit--loader--active');
//     })
//     .catch((error) => { console.error("Error:", error) });
// }
// function updateSelectedValues(selectedValues) {
//     let resultString = "";
//     for (let key in selectedValues) { if (selectedValues.hasOwnProperty(key)) { resultString += selectedValues[key] + "  "; }}
//     const selectElement = document.querySelector('.cus_hidden_select');
//     if (selectElement) {
//         const options = selectElement.querySelectorAll('option');
//         options.forEach((option) => {
//             let label = option.label.replace(/\//g, "").trim();
//             if (resultString.toString().trim() === label.toString()) {
//                 let optionValue = option.value; cusValSel = optionValue;
//                 let valPopup = document.querySelector('.ctm_var_edit--popup_wrapper');
//                 valPopup.setAttribute('data-sel-var-id', optionValue);
//             } 
//         });
//     } else { console.log("Select element with class 'cus_hidden_select' not found."); }
// }
// function updateCartWithId(item){
//     const selectedValues = {};const selectElements = item.querySelectorAll('.cus_option_select');
//     selectElements.forEach(select => { const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null; });
//     selectElements.forEach(select => { select.addEventListener('change', function () {
//         const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null;updateSelectedValues(selectedValues);
//     })});
// }
// // ------------ Cart Var Edit end-------------------





// // Wheel & Pipe Addon -- START
// function addOnItemIsChecked(item){
    
//     let item_parent = item.closest('.wheels_pipes_addon--item');
//     if(item_parent.classList.contains('w_p_a--item_checkbox--active')){ item_parent.classList.remove('w_p_a--item_checkbox--active') }
//     else{ item_parent.classList.add('w_p_a--item_checkbox--active') }
    
//     let parent_wrapper = item_parent.closest('.wheels_pipes_addon--wrapper');
//     let isActive = parent_wrapper.querySelectorAll('.w_p_a--item_checkbox--active');

//     if(isActive.length > 0){
//         parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
//         ? '' : parent_wrapper.classList.add('wheels_pipes_addon--wrapper--atc_active');
//     }else{
//         parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
//         ? parent_wrapper.classList.remove('wheels_pipes_addon--wrapper--atc_active')
//         : '';
//     }

//     updateAddOnItemPrice();
// }
// function addOnItemQtyUpdate(item, qty = 0){
//     let prd_info_parent = item.closest('.\\#product-meta');
//     let qty_span = prd_info_parent.querySelectorAll('.w_p_a--item_qty span');

//     if(qty_span.length > 0){
//         if(parseInt(item.value) > 0 || qty > 0){ 
//             if(qty > 0){ qty_span.forEach( i => i.innerHTML = qty ) }
//             else{ qty_span.forEach( i => i.innerHTML = item.value ) }
//         }
//         else{ qty_span.forEach( i => i.innerHTML = 1 ) }
        
//         updateAddOnItemPrice();
//     }
// }
// function updateAddOnItemPrice(){
//     let wheel_qty = document.getElementById('wheels--item-qty');
//     let pipe_qty = document.getElementById('pipes--item-qty');
//     let wheel_price = document.getElementById('wheels--item-price');
//     let pipe_price = document.getElementById('pipes--item-price');
//     // let prd_price = document.querySelector('.\\#product-meta .\\#price .\\@regular').dataset.price;

//     let wheel_final_price = (parseInt(wheel_qty.innerHTML) * parseInt(wheel_price.dataset.price)) / 100;
//     let pipe_final_price = (parseInt(pipe_qty.innerHTML) * parseInt(pipe_price.dataset.price)) / 100;
//     // let prd_final_price = (parseInt(prd_price) * parseInt(pipe_price.dataset.price)) / 100;
    
//     let curr_code = pipe_qty.closest('.wheels_pipes_addon--item_list').getAttribute('data-cur-code');
//     // let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheel_pipes_total_price');
//     let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheels_pipes_addon--total_price span');
//     let total;
    
//     wheel_price.innerHTML = `${curr_code} ${wheel_final_price.toFixed(2)}`;
//     pipe_price.innerHTML = `${curr_code} ${pipe_final_price.toFixed(2)}`;
    
//     if(wheel_price.closest('.w_p_a--item_checkbox--active') 
//         && pipe_price.closest('.w_p_a--item_checkbox--active')){
//         total = wheel_final_price + pipe_final_price;
//     }else if(wheel_price.closest('.w_p_a--item_checkbox--active')){ total = wheel_final_price }
//     else if(pipe_price.closest('.w_p_a--item_checkbox--active')){ total = pipe_final_price }
//     else{ total = false }

//     // console.log('total', total);    
//     if(total){ total_price.innerHTML = `${curr_code} ${total.toFixed(2)}` }
//     else{ total_price.innerHTML = `` }
// }
// function addOnItemATCClick(item){
    
//     let parent = item.closest('.wheels_pipes_addon--wrapper');
//     let isAddOn = parent.querySelectorAll('.w_p_a--item_checkbox--active');

//     if(isAddOn.length > 0){

//         let parrr = item.closest('.wheels_pipes_addon--wrapper');
//         parrr.classList.add('w_p_a--atc_loader_active');        

//         let formData = { items: [] };
//         isAddOn.forEach( a => {
//             let id = parseInt(a.getAttribute('data-id'));
//             let qty = parseInt(a.querySelector('.w_p_a--item_qty span').innerHTML);
//             formData.items.push({ id: id, quantity: qty });
//         })
        
//         fetch(window.Shopify.routes.root + "cart/add.js", {
//             method: "POST",
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(formData),
//         })
//         .then(() => {
//             let grand_parent = item.closest('.\\#product-meta');
//             grand_parent.querySelector('button.\\#button[type="submit"]').click();
//             parrr.classList.remove('w_p_a--atc_loader_active');
//         })
//         .catch((error) => { console.error("Error:", error) });
//     }else{ console.log('NO ADD-ONs SELECTED') }
    
// }
// function updateAddOnitemVariant(item){
//     let grand_parent = item.closest('.\\#product-meta');
//     let parent = item.closest('product-variant-selector');
//     let var_val = parseInt(parent.querySelector(`[tier_val="true"] h5 span`).innerHTML);
//     let pipe_json = JSON.parse(grand_parent.querySelector('[data-pipes-var-json]').innerHTML);

//     if(pipe_json){
//         let pipe_varr = pipe_json.find(p => p.title.includes(var_val));
//         let pipe_item = grand_parent.querySelector('[data-pipes-var-json]').closest('.wheels_pipes_addon--item');
    
//         pipe_item.setAttribute('data-id', pipe_varr.id);
//         pipe_item.querySelector('.pipe_var_title').innerHTML = pipe_varr.title;
//         pipe_item.querySelector('.w_p_a--item_price span').setAttribute('data-price', pipe_varr.price);
    
//         updateAddOnItemPrice();
//     }

// }
// // Wheel & Pipe Addon -- END

// document.addEventListener('click', (e) => {
//     let item = e.target;

//     if(item.closest('.ctm_var_edit')){
//         let i;
//         if(item.closest('.ctm_var_edit--cart-page')){ i = item.closest('.\\#cart-item') }
//         else{ i = item.closest('.\\#product-card-min') }
//         showEditVar(i);
//     }

//     if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){
//         let i = item.closest('.\\#product-card-min');
//         hideEditVar(i);
//     }

//     if(item.closest('.\\#modal-popup-dialog')){
//         setTimeout(() => {
//             let i = item.closest('.\\#modal-popup-dialog');
//             if(!i.attributes.open){ hideEditVar() }
//         }, 500);   
//     }
    
//     if(item.closest('.ctm_var-edit--btn_apply')){
//         let i;
//         if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item') }
//         else{ i = item.closest('.\\#product-card-min') }
//         varChangeStart(i);
//     }

//     if(item.closest('.ctm_form_field--radio')){

//         let grand_parent = item.closest('.\\#grid');
//         let parent = item.closest('.ctm_form_field--radio');
//         let i = parent.querySelector('input');
        
//         // parent.classList.contains('ctm_form_field--radio_other') || 
//         if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
//             let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
//             let isTextThere = parent.querySelectorAll('.radio_other_field').length;

//             let name = i.name;
//             let placeholder = i.placeholder
            
//             let html = document.createElement('input');
//             html.className = 'radio_other_field';
//             html.type = 'text';
//             html.name = name;
//             html.placeholder = placeholder;
            
//             if(otherRadio && !isTextThere ){ parent.appendChild(html)}

//         }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
//             let isTextThere = grand_parent.querySelectorAll('.radio_other_field');
//             isTextThere.forEach(e => { e.remove() });
//         }
        
//     }
//     if (item.closest('.cus_data_var_id')) {
//         // console.log('ran');
//         let i = item.closest('.cus_data_var_id')
//         updateCartWithId(i)
//     }


//     // Titan prd Add-on Events
//     if(item.closest('.wheels_pipes_addon--item')){ addOnItemIsChecked(item) }
//     if(item.closest('.wheels_pipes_addon--atc')){ addOnItemATCClick(item) }

//     //Combo Unit Currently in-active
//     if(item.closest('.combo_units--item')){
//         let i = item.closest('.combo_units--item');
//         let qty_input = item.closest('.\\#product-qty-selector').querySelector('input');
//         qty_input.value = i.dataset.val;
//         addOnItemQtyUpdate(item, parseInt(i.dataset.val));
//     }

//     if(item.closest('.quantity_selector_button')){
//         let i = item.closest('.quantity_selector_button');
//         let action = i.dataset.action;
//         let input = item.closest('div').querySelector('input[name="quantity"]');

//         if(action == '+'){ input.value = parseInt(input.value) + 1 }
//         else if(action == '-'){  
//             if(input.value != 1){ input.value = parseInt(input.value) - 1}
//             else{ input.value = 1 }
//         }

//         input.dispatchEvent(new Event('change', { bubbles: true}));
//     }
// })     

// document.addEventListener('change', (e) => {
//     let item = e.target;

//     if( item.closest('.\\#product-qty-selector-input[name="quantity"]')){ addOnItemQtyUpdate(item) }
//     if( item.closest('product-variant-selector')){ updateAddOnitemVariant(item) }
// })



// document.addEventListener('DOMContentLoaded', function() {
//   // Get all navigation items with dropdowns
//   const navItems = document.querySelectorAll('.\\#main-navigation-item[data-drop]');
  
//   // Close all dropdowns except the one that was clicked
//   function closeAllDropdowns(exceptThis) {
//     navItems.forEach(item => {
//       if (item !== exceptThis) {
//         item.classList.remove('active');
//         item.querySelector('.\\#main-navigation-dropdown').style.display = 'none';
//       }
//     });
//   }
  
//   // Add click event listeners
//   navItems.forEach(item => {
//     const link = item.querySelector('.\\#main-navigation-link');
//     const dropdown = item.querySelector('.\\#main-navigation-dropdown');
    
//     // Toggle dropdown on click
//     link.addEventListener('click', function(e) {
//       e.preventDefault();
      
//       // Close all other dropdowns
//       closeAllDropdowns(item);
      
//       // Toggle current dropdown
//       item.classList.toggle('active');
//       dropdown.style.display = item.classList.contains('active') ? 'block' : 'none';
//     });
//   });
  
//   // Close dropdowns when clicking outside
//   document.addEventListener('click', function(e) {
//     if (!e.target.closest('.\\#main-navigation-item[data-drop]')) {
//       closeAllDropdowns(null);
//     }
//   });
// });





// // document.addEventListener('click', (e) => {
// //     let item = e.target;
// //     if(item.closest('.ctm_var_edit')){ let i; if(item.closest('.ctm_var_edit--cart-page')){i=item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')} showEditVar(i)}
// //     if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){let i = item.closest('.\\#product-card-min');hideEditVar(i)}
// //     if(item.closest('.\\#modal-popup-dialog')){ setTimeout(() => { let i = item.closest('.\\#modal-popup-dialog'); if(!i.attributes.open){ hideEditVar()}}, 500);}
// //     if(item.closest('.ctm_var-edit--btn_apply')){ let i;if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')}varChangeStart(i);}
// //     if(item.closest('.ctm_form_field--radio')){
// //         let grand_parent = item.closest('.\\#grid');let parent = item.closest('.ctm_form_field--radio');let i = parent.querySelector('input');
// //         if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
// //             let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
// //             let isTextThere = parent.querySelectorAll('.radio_other_field').length;let name = i.name;let placeholder = i.placeholder;let html = document.createElement('input');
// //             html.className = 'radio_other_field';html.type = 'text';html.name = name;html.placeholder = placeholder;if(otherRadio && !isTextThere ){ parent.appendChild(html)}
// //         }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){let isTextThere = grand_parent.querySelectorAll('.radio_other_field');isTextThere.forEach(e => { e.remove() });}
// //     }
// //     if (item.closest('.cus_data_var_id')){let i = item.closest('.cus_data_var_id'); updateCartWithId(i);}
// // })     


function debounce(func, delay) {let timeoutId; return function (...args) {const context = this; clearTimeout(timeoutId);timeoutId = setTimeout(() => { func.apply(context, args) }, delay)}}
// ------------ Cart Var Edit start -------------------
// function showEditVar(i){
//     let popup = i.querySelector('.ctm_var_edit--popup');
//     popup.classList.add('ctm_var_edit--popup--active');
//     setTimeout(() => { popup.classList.add('ctm_var_edit--popup--active_animation') }, 100);
// }

function showEditVar(item) {
    let popup = item.querySelector('.ctm_var_edit--popup');
    let wrapper = item.querySelector('.ctm_var_edit--popup_wrapper');

    popup.classList.add('ctm_var_edit--popup--active');
    setTimeout(() => {
        popup.classList.add('ctm_var_edit--popup--active_animation');
    }, 100);

    const currentVariantId = wrapper.getAttribute('data-cart-var-id');

    // Sync hidden select by variant ID directly (this is fine, IDs are clean)
    const hiddenSelect = wrapper.querySelector('.cus_hidden_select');
    if (hiddenSelect) {
        hiddenSelect.value = currentVariantId;
    }

    wrapper.setAttribute('data-sel-var-id', currentVariantId);

    // Also sync the visible selects using the hidden select's selected option text
    // so the dropdowns show the correct current values on open
    const selectedOption = hiddenSelect?.options[hiddenSelect.selectedIndex];
    if (selectedOption) {
        const parts = selectedOption.text.split('/').map(p => p.trim());
        const visibleSelects = wrapper.querySelectorAll('.cus_option_select');
        visibleSelects.forEach((select, i) => {
            if (parts[i]) {
                // Match by option text not value
                Array.from(select.options).forEach(opt => {
                    if (opt.text.trim() === parts[i]) {
                        select.value = opt.value;
                    }
                });
            }
        });
    }
}

function hideEditVar(i = false){
    let popup = document.querySelector('.ctm_var_edit--popup--active');
    if(i){ popup = i.querySelector('.ctm_var_edit--popup--active') }
    popup?.classList.remove('ctm_var_edit--popup--active_animation');
    setTimeout(() => { popup?.classList.remove('ctm_var_edit--popup--active') }, 250);
}


function updateSelectedValues(wrapper) {
    const selects = wrapper.querySelectorAll('.cus_option_select');
    const hiddenSelect = wrapper.querySelector('.cus_hidden_select');

    let selectedTitle = [];

    selects.forEach(select => {
        selectedTitle.push(select.value);
    });

    selectedTitle = selectedTitle.join(' / ').trim();

    hiddenSelect.querySelectorAll('option').forEach(option => {
        if (option.text.trim() === selectedTitle) {
            hiddenSelect.value = option.value;
            wrapper.setAttribute('data-sel-var-id', option.value);
        }
    });
}

document.addEventListener("change", function(e) {

    if (!e.target.classList.contains("cus_option_select")) return;

    const wrapper = e.target.closest(".ctm_var_edit--popup_wrapper");
    if (!wrapper) return;

    const selects = wrapper.querySelectorAll(".cus_option_select");
    const hiddenSelect = wrapper.querySelector(".cus_hidden_select");

    const normalize = (str) => str.replace(/\s+/g, ' ').trim();

    let selectedOptions = [];

    selects.forEach(select => {
        // Use selectedOptions[selectedIndex].text NOT select.value
        // because value attribute is broken by special chars like " in option values
        const selectedText = select.options[select.selectedIndex]?.text;
        if (selectedText) selectedOptions.push(normalize(selectedText));
    });

    const variantTitle = selectedOptions.join(" / ");

    console.log('Built variant title:', variantTitle);

    let matched = false;

    hiddenSelect.querySelectorAll("option").forEach(option => {
        if (normalize(option.text) === variantTitle) {
            hiddenSelect.value = option.value;
            wrapper.setAttribute("data-sel-var-id", option.value);
            matched = true;
        }
    });

    if (!matched) {
        console.log("No match for:", variantTitle);
        console.log("Available:", Array.from(hiddenSelect.options).map(o => normalize(o.text)));
    }
});

function updateCartWithId(item){
    const selectedValues = {};const selectElements = item.querySelectorAll('.cus_option_select');
    selectElements.forEach(select => { const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null; });
    selectElements.forEach(select => { select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null;
        updateSelectedValues(selectedValues);
    })});
}

async function cartPageUpdate(wrapper) {
    const lineKey = wrapper.getAttribute("data-line-key");
    const newVariantId = wrapper.getAttribute("data-sel-var-id");
    const quantity = parseInt(wrapper.getAttribute("data-cart-var-qty"));

    if (!lineKey || !newVariantId) return;

    const loader = wrapper.querySelector('.ctm_var-edit--loader');
    loader.classList.add('ctm_var-edit--loader--active');

    try {
        // 1. Add new variant
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariantId, quantity })
        });

        // 2. Remove old variant
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
        });

        // 3. Fetch updated cart section
        const cartURL = window.dynamicURLs['cart'];
        const cartSectionRes = await fetch(`${cartURL}?section_id=r_cart`);
        const cartSectionText = await cartSectionRes.text();
        const $cartDoc = new DOMParser().parseFromString(cartSectionText, 'text/html');

        // 4. Update cart items
        const newItems = $cartDoc.querySelector('[data-cart-items]');
        const currentItems = document.querySelector('[data-cart-items]');
        if (newItems && currentItems) {
            currentItems.replaceChildren(...newItems.cloneNode(true).childNodes);
        }

        // 5. Update subtotal
        const newSubtotal = $cartDoc.querySelector('[data-cart-subtotal-block]');
        const currentSubtotal = document.querySelector('[data-cart-subtotal-block]');
        if (newSubtotal && currentSubtotal) {
            currentSubtotal.replaceChildren(...newSubtotal.cloneNode(true).childNodes);
        }

        // 6. Update free shipping block
        const newFreeShipping = $cartDoc.querySelector('[data-cart-free-shipping-block]');
        const currentFreeShipping = document.querySelector('[data-cart-free-shipping-block]');
        if (newFreeShipping && currentFreeShipping) {
            currentFreeShipping.replaceChildren(...newFreeShipping.cloneNode(true).childNodes);
        }

        // 7. Handle empty cart state
        const newCount = $cartDoc.querySelector('[data-cart-counter]')?.innerText ?? '0';
        const hasItems = Number(newCount) > 0;
        const emptyMsg = document.querySelector('[data-cart-empty]');
        const itemsContainer = document.querySelector('[data-cart-items-container]');
        if (emptyMsg) hasItems ? emptyMsg.setAttribute('hidden', '') : emptyMsg.removeAttribute('hidden');
        if (itemsContainer) hasItems ? itemsContainer.removeAttribute('hidden') : itemsContainer.setAttribute('hidden', '');

    } catch (err) {
        console.error(err);
    } finally {
        loader.classList.remove('ctm_var-edit--loader--active');
    }
}

async function cartDrawerUpdate(wrapper) {
    const lineKey = wrapper.getAttribute("data-line-key");
    const newVariantId = wrapper.getAttribute("data-sel-var-id");
    const quantity = parseInt(wrapper.getAttribute("data-cart-var-qty"));

    if (!lineKey || !newVariantId) return;

    const loader = wrapper.querySelector('.ctm_var-edit--loader');
    loader.classList.add('ctm_var-edit--loader--active');

    try {
        // 1. Add new variant
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariantId, quantity })
        });

        // 2. Remove old variant
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
        });

        const { Routes, parseHTML } = await importModule('Utils');
        const SECTION_DRAWER = 'g_cart-drawer';

        // 3. Fetch cart meta
        const metaRes = await fetch(`${Routes('cart')}?view=meta`);
        const { count, ...metaData } = await metaRes.json();

        // 4. Fetch drawer section HTML
        const drawerRes = await fetch(`${Routes('root')}?section_id=${SECTION_DRAWER}`);
        const drawerSection = await drawerRes.text();

        // 5. Fetch cart section HTML — needed for cart key getters
        const cartSectionRes = await fetch(`${Routes('cart')}?section_id=r_cart`);
        const $cartDoc = parseHTML(await cartSectionRes.text());

        // 6. Publish via cart-provider — this updates drawer, counter, cart-total
        const { publishEvent } = await importModule('Utils');
        publishEvent('cart:update', {
            meta: { count: Number(count), ...metaData },
            drawer: {
                section: drawerSection,
                open: true
            },
            cart: {
                getCount: () => $cartDoc.querySelector('[data-cart-counter]')?.innerText ?? '0',
                getItems: () => $cartDoc.querySelector('[data-cart-items]'),
                getSubtotalBlock: () => $cartDoc.querySelector('[data-cart-subtotal-block]'),
                getFreeShippingBlock: () => $cartDoc.querySelector('[data-cart-free-shipping-block]')
            }
        });

    } catch (err) {
        console.error(err);
    } finally {
        loader.classList.remove('ctm_var-edit--loader--active');
    }
}

document.addEventListener("click", function (e) {

    // APPLY BUTTON
    if (e.target.closest(".ctm_var-edit--btn_apply")) {
        const wrapper = e.target.closest(".ctm_var_edit--popup_wrapper");
        if (!wrapper) return;

        if (window.location.pathname.includes('/cart')) {
            // Cart page — direct DOM update
            cartPageUpdate(wrapper);
        } else {
            // Cart drawer — publish/subscribe flow
            cartDrawerUpdate(wrapper);
        }
    }

    // CANCEL BUTTON
    if (e.target.closest(".ctm_var-edit--btn_cancel")) {
        const popup = e.target.closest(".ctm_var_edit--popup");
        if (!popup) return;
        popup.classList.remove("ctm_var_edit--popup--active");
        popup.classList.remove("ctm_var_edit--popup--active_animation");
    }
});


// ------------ Cart Var Edit end-------------------





// Wheel & Pipe Addon -- START
// function addOnItemIsChecked(item){
    
//     let item_parent = item.closest('.wheels_pipes_addon--item');
//     if(item_parent.classList.contains('w_p_a--item_checkbox--active')){ item_parent.classList.remove('w_p_a--item_checkbox--active') }
//     else{ item_parent.classList.add('w_p_a--item_checkbox--active') }
    
//     let parent_wrapper = item_parent.closest('.wheels_pipes_addon--wrapper');
//     let isActive = parent_wrapper.querySelectorAll('.w_p_a--item_checkbox--active');

//     if(isActive.length > 0){
//         parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
//         ? '' : parent_wrapper.classList.add('wheels_pipes_addon--wrapper--atc_active');
//     }else{
//         parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
//         ? parent_wrapper.classList.remove('wheels_pipes_addon--wrapper--atc_active')
//         : '';
//     }

//     updateAddOnItemPrice();
// }
// function addOnItemQtyUpdate(item, qty = 0){
//     let prd_info_parent = item.closest('.\\#product-meta');
//     let qty_span = prd_info_parent.querySelectorAll('.w_p_a--item_qty span');

//     if(qty_span.length > 0){
//         if(parseInt(item.value) > 0 || qty > 0){ 
//             if(qty > 0){ qty_span.forEach( i => i.innerHTML = qty ) }
//             else{ qty_span.forEach( i => i.innerHTML = item.value ) }
//         }
//         else{ qty_span.forEach( i => i.innerHTML = 1 ) }
        
//         updateAddOnItemPrice();
//     }
// }
// function updateAddOnItemPrice(){
//     let wheel_qty = document.getElementById('wheels--item-qty');
//     let pipe_qty = document.getElementById('pipes--item-qty');
//     let wheel_price = document.getElementById('wheels--item-price');
//     let pipe_price = document.getElementById('pipes--item-price');
//     // let prd_price = document.querySelector('.\\#product-meta .\\#price .\\@regular').dataset.price;

//     let wheel_final_price = (parseInt(wheel_qty.innerHTML) * parseInt(wheel_price.dataset.price)) / 100;
//     let pipe_final_price = (parseInt(pipe_qty.innerHTML) * parseInt(pipe_price.dataset.price)) / 100;
//     // let prd_final_price = (parseInt(prd_price) * parseInt(pipe_price.dataset.price)) / 100;
    
//     let curr_code = pipe_qty.closest('.wheels_pipes_addon--item_list').getAttribute('data-cur-code');
//     // let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheel_pipes_total_price');
//     let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheels_pipes_addon--total_price span');
//     let total;
    
//     wheel_price.innerHTML = `${curr_code} ${wheel_final_price.toFixed(2)}`;
//     pipe_price.innerHTML = `${curr_code} ${pipe_final_price.toFixed(2)}`;
    
//     if(wheel_price.closest('.w_p_a--item_checkbox--active') 
//         && pipe_price.closest('.w_p_a--item_checkbox--active')){
//         total = wheel_final_price + pipe_final_price;
//     }else if(wheel_price.closest('.w_p_a--item_checkbox--active')){ total = wheel_final_price }
//     else if(pipe_price.closest('.w_p_a--item_checkbox--active')){ total = pipe_final_price }
//     else{ total = false }

//     // console.log('total', total);    
//     if(total){ total_price.innerHTML = `${curr_code} ${total.toFixed(2)}` }
//     else{ total_price.innerHTML = `` }
// }
// function addOnItemATCClick(item){
    
//     let parent = item.closest('.wheels_pipes_addon--wrapper');
//     let isAddOn = parent.querySelectorAll('.w_p_a--item_checkbox--active');

//     if(isAddOn.length > 0){

//         let parrr = item.closest('.wheels_pipes_addon--wrapper');
//         parrr.classList.add('w_p_a--atc_loader_active');        

//         let formData = { items: [] };
//         isAddOn.forEach( a => {
//             let id = parseInt(a.getAttribute('data-id'));
//             let qty = parseInt(a.querySelector('.w_p_a--item_qty span').innerHTML);
//             formData.items.push({ id: id, quantity: qty });
//         })
        
//         fetch(window.Shopify.routes.root + "cart/add.js", {
//             method: "POST",
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(formData),
//         })
//         .then(() => {
//             let grand_parent = item.closest('.\\#product-meta');
//             grand_parent.querySelector('button.\\#button[type="submit"]').click();
//             parrr.classList.remove('w_p_a--atc_loader_active');
//         })
//         .catch((error) => { console.error("Error:", error) });
//     }else{ console.log('NO ADD-ONs SELECTED') }
    
// }
// function updateAddOnitemVariant(item){
//     let grand_parent = item.closest('.\\#product-meta');
//     let parent = item.closest('product-variant-selector');
//     let var_val = parseInt(parent.querySelector(`[tier_val="true"] h5 span`).innerHTML);
//     let pipe_json = JSON.parse(grand_parent.querySelector('[data-pipes-var-json]').innerHTML);

//     if(pipe_json){
//         let pipe_varr = pipe_json.find(p => p.title.includes(var_val));
//         let pipe_item = grand_parent.querySelector('[data-pipes-var-json]').closest('.wheels_pipes_addon--item');
    
//         pipe_item.setAttribute('data-id', pipe_varr.id);
//         pipe_item.querySelector('.pipe_var_title').innerHTML = pipe_varr.title;
//         pipe_item.querySelector('.w_p_a--item_price span').setAttribute('data-price', pipe_varr.price);
    
//         updateAddOnItemPrice();
//     }

// }

// // 1. Configuration: Define the specific product handle for the Titan
const TITAN_HANDLE = 'boot-rack-47-wide-rustproof-with-containers-2-to-8-shelves-rakabot-titan';

/**
 * Helper to check if we are on the Titan page
 */
function isTitanProduct() {
    return window.location.pathname.includes(TITAN_HANDLE);
}

/**
 * Toggles the checkbox state
 */
function addOnItemIsChecked(item) {
    let item_parent = item.closest('.wheels_pipes_addon--item');
    item_parent.classList.toggle('w_p_a--item_checkbox--active');
    
    let parent_wrapper = item_parent.closest('.wheels_pipes_addon--wrapper');
    let isActive = parent_wrapper.querySelectorAll('.w_p_a--item_checkbox--active');

    if (isActive.length > 0) {
        if (!parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')) {
            parent_wrapper.classList.add('wheels_pipes_addon--wrapper--atc_active');
        }
    } else {
        parent_wrapper.classList.remove('wheels_pipes_addon--wrapper--atc_active');
    }

    updateAddOnItemPrice();
}

/**
 * Updates quantity spans
 */
function addOnItemQtyUpdate(item, qty = 0) {
    let prd_info_parent = item.closest('.\\#product-meta');
    
    if (isTitanProduct()) {
        // --- TITAN LOGIC (Old Code) ---
        let qty_span = prd_info_parent.querySelectorAll('.w_p_a--item_qty span');
        if (qty_span.length > 0) {
            let finalQty = (parseInt(item.value) > 0 || qty > 0) ? (qty > 0 ? qty : item.value) : 1;
            qty_span.forEach(i => i.innerHTML = finalQty);
        }
    } else {
        // --- DYNAMIC LOGIC (New Code) ---
        let qty_spans = prd_info_parent.querySelectorAll('.addon-item-qty');
        if (qty_spans.length > 0) {
            let newQty = (parseInt(item.value) > 0) ? item.value : (qty > 0 ? qty : 1);
            qty_spans.forEach(span => span.innerHTML = newQty);
        }
    }
    updateAddOnItemPrice();
}

/**
 * Calculates and displays totals
 */
// function updateAddOnItemPrice() {
//     const wrapper = document.querySelector('.wheels_pipes_addon');
//     if (!wrapper) return;

//     if (isTitanProduct()) {
//         // --- TITAN LOGIC (Specific IDs for Wheels/Pipes) ---
//         let wheel_qty = document.getElementById('wheels--item-qty');
//         let pipe_qty = document.getElementById('pipes--item-qty');
//         let wheel_price = document.getElementById('wheels--item-price');
//         let pipe_price = document.getElementById('pipes--item-price');
        
//         if (!wheel_qty || !pipe_qty) return;

//         let wheel_final_price = (parseInt(wheel_qty.innerHTML) * parseInt(wheel_price.dataset.price)) / 100;
//         let pipe_final_price = (parseInt(pipe_qty.innerHTML) * parseInt(pipe_price.dataset.price)) / 100;
        
//         let curr_code = pipe_qty.closest('.wheels_pipes_addon--item_list').getAttribute('data-cur-code');
//         let total_price_span = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheels_pipes_addon--total_price span');
        
//         wheel_price.innerHTML = `${curr_code} ${wheel_final_price.toFixed(2)}`;
//         pipe_price.innerHTML = `${curr_code} ${pipe_final_price.toFixed(2)}`;
        
//         let total = 0;
//         let active = false;
//         if (wheel_price.closest('.w_p_a--item_checkbox--active')) { total += wheel_final_price; active = true; }
//         if (pipe_price.closest('.w_p_a--item_checkbox--active')) { total += pipe_final_price; active = true; }

//         total_price_span.innerHTML = active ? `${curr_code} ${total.toFixed(2)}` : "";

//     } else {
//         // --- DYNAMIC LOGIC (Metafield Loop) ---
//         const itemList = wrapper.querySelector('.wheels_pipes_addon--item_list');
//         const curr_code = itemList.getAttribute('data-cur-code') || '$';
//         const total_price_display = wrapper.querySelector('.wheels_pipes_addon--total_price span');
//         let grand_total = 0;
//         let anyActive = false;

//         wrapper.querySelectorAll('.wheels_pipes_addon--item').forEach(item => {
//             const qty_el = item.querySelector('.addon-item-qty');
//             const price_el = item.querySelector('.addon-item-price');
//             if (qty_el && price_el) {
//                 const qty = parseInt(qty_el.innerHTML) || 1;
//                 const price_per_unit = parseInt(price_el.getAttribute('data-price'));
//                 const line_total = (qty * price_per_unit) / 100;
//                 price_el.innerHTML = `${curr_code}${line_total.toFixed(2)}`;
//                 if (item.classList.contains('w_p_a--item_checkbox--active')) {
//                     grand_total += line_total;
//                     anyActive = true;
//                 }
//             }
//         });
//         total_price_display.innerHTML = anyActive ? `${curr_code}${grand_total.toFixed(2)}` : "";
//     }
// }
function updateAddOnItemPrice() {
    const wrapper = document.querySelector('.wheels_pipes_addon');
    if (!wrapper) return;

    const itemList = wrapper.querySelector('.wheels_pipes_addon--item_list');
    const curr_code = itemList.getAttribute('data-cur-code') || '$';
    const total_price_display = wrapper.querySelector('.wheels_pipes_addon--total_price span');

    let grand_total = 0;
    let anyActive = false;

    wrapper.querySelectorAll('.wheels_pipes_addon--item').forEach(item => {

        if (item.classList.contains('w_p_a--item_checkbox--active')) {

            const price_el = item.querySelector('[data-price]');
            const qty_el =
                item.querySelector('.addon-item-qty') ||
                item.querySelector('.w_p_a--item_qty span');

            if (!price_el) return;

            const qty = qty_el ? parseInt(qty_el.innerHTML) || 1 : 1;
            const price_per_unit = parseInt(price_el.getAttribute('data-price')) || 0;

            const line_total = (qty * price_per_unit) / 100;

            grand_total += line_total;
            anyActive = true;
        }
    });

    total_price_display.innerHTML = anyActive
        ? `${curr_code} ${grand_total.toFixed(2)}`
        : "";
}

/**
 * AJAX Add to Cart
 */
function addOnItemATCClick(item) {
    let parent = item.closest('.wheels_pipes_addon--wrapper');
    let isAddOn = parent.querySelectorAll('.w_p_a--item_checkbox--active');

    if (isAddOn.length > 0) {
        parent.classList.add('w_p_a--atc_loader_active');
        let formData = { items: [] };

        isAddOn.forEach(a => {
            let id = parseInt(a.getAttribute('data-id'));
            // Determine qty selector based on product
            let qtySelector = isTitanProduct() ? '.w_p_a--item_qty span' : '.addon-item-qty';
            let qty = parseInt(a.querySelector(qtySelector).innerHTML);
            formData.items.push({ id: id, quantity: qty });
        });
        
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(() => {
            let grand_parent = item.closest('.\\#product-meta');
            let mainSubmit = grand_parent.querySelector('button.\\#button[type="submit"]');
            if (mainSubmit) mainSubmit.click();
            parent.classList.remove('w_p_a--atc_loader_active');
        })
        .catch((error) => { 
            console.error("Error:", error);
            parent.classList.remove('w_p_a--atc_loader_active');
        });
    }
}

/**
 * Variant Update (Specific to Titan/Pipes logic)
 */
function updateAddOnitemVariant(item) {
    // This logic seems specific to the Pipe JSON, so we check if that JSON exists first
    let grand_parent = item.closest('.\\#product-meta');
    let json_el = grand_parent.querySelector('[data-pipes-var-json]');
    
    if (isTitanProduct() && json_el) {
        let parent = item.closest('product-variant-selector');
        let var_val = parseInt(parent.querySelector(`[tier_val="true"] h5 span`).innerHTML);
        let pipe_json = JSON.parse(json_el.innerHTML);

        let pipe_varr = pipe_json.find(p => p.title.includes(var_val));
        let pipe_item = json_el.closest('.wheels_pipes_addon--item');
    
        if (pipe_varr) {
            pipe_item.setAttribute('data-id', pipe_varr.id);
            pipe_item.querySelector('.pipe_var_title').innerHTML = pipe_varr.title;
            pipe_item.querySelector('.w_p_a--item_price span').setAttribute('data-price', pipe_varr.price);
            updateAddOnItemPrice();
        }
    }
}
// Wheel & Pipe Addon -- END

document.addEventListener('click', (e) => {
    let item = e.target;

    if(item.closest('.ctm_var_edit')){
        let i;
        if(item.closest('.ctm_var_edit--cart-page')){ i = item.closest('.\\#cart-item') }
        else{ i = item.closest('.\\#product-card-min') }
        showEditVar(i);
    }

    if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){
        let i = item.closest('.\\#product-card-min');
        hideEditVar(i);
    }

    if(item.closest('.\\#modal-popup-dialog')){
        setTimeout(() => {
            let i = item.closest('.\\#modal-popup-dialog');
            if(!i.attributes.open){ hideEditVar() }
        }, 500);   
    }
    
    // if(item.closest('.ctm_var-edit--btn_apply')){
    //     let i;
    //     if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item') }
    //     else{ i = item.closest('.\\#product-card-min') }
    //     varChangeStart(i);
    // }

    if(item.closest('.ctm_form_field--radio')){

        let grand_parent = item.closest('.\\#grid');
        let parent = item.closest('.ctm_form_field--radio');
        let i = parent.querySelector('input');
        
        // parent.classList.contains('ctm_form_field--radio_other') || 
        if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
            let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
            let isTextThere = parent.querySelectorAll('.radio_other_field').length;

            let name = i.name;
            let placeholder = i.placeholder
            
            let html = document.createElement('input');
            html.className = 'radio_other_field';
            html.type = 'text';
            html.name = name;
            html.placeholder = placeholder;
            
            if(otherRadio && !isTextThere ){ parent.appendChild(html)}

        }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
            let isTextThere = grand_parent.querySelectorAll('.radio_other_field');
            isTextThere.forEach(e => { e.remove() });
        }
        
    }
    if (item.closest('.cus_data_var_id')) {
        // console.log('ran');
        let i = item.closest('.cus_data_var_id')
        updateCartWithId(i)
    }


    // Titan prd Add-on Events
    if(item.closest('.wheels_pipes_addon--item')){ addOnItemIsChecked(item) }
    if(item.closest('.wheels_pipes_addon--atc')){ addOnItemATCClick(item) }

    //Combo Unit Currently in-active
    if(item.closest('.combo_units--item')){
        let i = item.closest('.combo_units--item');
        let qty_input = item.closest('.\\#product-qty-selector').querySelector('input');
        qty_input.value = i.dataset.val;
        addOnItemQtyUpdate(item, parseInt(i.dataset.val));
    }

    if(item.closest('.quantity_selector_button')){
        let i = item.closest('.quantity_selector_button');
        let action = i.dataset.action;
        let input = item.closest('div').querySelector('input[name="quantity"]');

        if(action == '+'){ input.value = parseInt(input.value) + 1 }
        else if(action == '-'){  
            if(input.value != 1){ input.value = parseInt(input.value) - 1}
            else{ input.value = 1 }
        }

        input.dispatchEvent(new Event('change', { bubbles: true}));
    }
})     

document.addEventListener('change', (e) => {
    let item = e.target;

    if( item.closest('.\\#product-qty-selector-input[name="quantity"]')){ addOnItemQtyUpdate(item) }
    if( item.closest('product-variant-selector')){ updateAddOnitemVariant(item) }
})

document.addEventListener('DOMContentLoaded', function() {
  // Get all navigation items with dropdowns
  const navItems = document.querySelectorAll('.\\#main-navigation-item[data-drop]');
  
  // Close all dropdowns except the one that was clicked
  function closeAllDropdowns(exceptThis) {
    navItems.forEach(item => {
      if (item !== exceptThis) {
        item.classList.remove('active');
        item.querySelector('.\\#main-navigation-dropdown').style.display = 'none';
      }
    });
  }
  
  // Add click event listeners
  navItems.forEach(item => {
    const link = item.querySelector('.\\#main-navigation-link');
    const dropdown = item.querySelector('.\\#main-navigation-dropdown');
    
    // Toggle dropdown on click
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Close all other dropdowns
      closeAllDropdowns(item);
      
      // Toggle current dropdown
      item.classList.toggle('active');
      dropdown.style.display = item.classList.contains('active') ? 'block' : 'none';
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.\\#main-navigation-item[data-drop]')) {
      closeAllDropdowns(null);
    }
  });
});





// document.addEventListener('click', (e) => {
//     let item = e.target;
//     if(item.closest('.ctm_var_edit')){ let i; if(item.closest('.ctm_var_edit--cart-page')){i=item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')} showEditVar(i)}
//     if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){let i = item.closest('.\\#product-card-min');hideEditVar(i)}
//     if(item.closest('.\\#modal-popup-dialog')){ setTimeout(() => { let i = item.closest('.\\#modal-popup-dialog'); if(!i.attributes.open){ hideEditVar()}}, 500);}
//     if(item.closest('.ctm_var-edit--btn_apply')){ let i;if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')}varChangeStart(i);}
//     if(item.closest('.ctm_form_field--radio')){
//         let grand_parent = item.closest('.\\#grid');let parent = item.closest('.ctm_form_field--radio');let i = parent.querySelector('input');
//         if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
//             let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
//             let isTextThere = parent.querySelectorAll('.radio_other_field').length;let name = i.name;let placeholder = i.placeholder;let html = document.createElement('input');
//             html.className = 'radio_other_field';html.type = 'text';html.name = name;html.placeholder = placeholder;if(otherRadio && !isTextThere ){ parent.appendChild(html)}
//         }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){let isTextThere = grand_parent.querySelectorAll('.radio_other_field');isTextThere.forEach(e => { e.remove() });}
//     }
//     if (item.closest('.cus_data_var_id')){let i = item.closest('.cus_data_var_id'); updateCartWithId(i);}
// })     

// -------------------assembly-product----------------------------------

document.addEventListener("DOMContentLoaded", function() {

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function updateAssembly() {

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!variantInput) return;

    const variantJSON = document.querySelector('[data-variants-json]');
    if (!variantJSON) return;

    const mainVariants = JSON.parse(variantJSON.textContent);
    const mainVariant = mainVariants.find(v => v.id == variantInput.value);
    if (!mainVariant) return;

    const numberMatch = mainVariant.title.match(/\d+/);
    if (!numberMatch) return;

    const selectedNumber = numberMatch[0];

    document.querySelectorAll(".assembly-product").forEach(function(item) {

      const jsonScript = item.querySelector(".assembly-variants-json");
      if (!jsonScript) return;

      const variants = JSON.parse(jsonScript.textContent);

      let matchedVariant = null;

      for (let i = 0; i < variants.length; i++) {
        if (variants[i].title.includes(selectedNumber)) {
          matchedVariant = variants[i];
          break;
        }
      }

      if (!matchedVariant) return;

      // Update variant ID
      item.setAttribute("data-id", matchedVariant.id);

      // Update title
      const titleEl = item.querySelector(".pipe_var_title");
      if (titleEl) {
        titleEl.innerText = matchedVariant.title;
      }

      // 🔥 HARD PRICE UPDATE
      const priceEls = item.querySelectorAll(".assembly--item-price");

      priceEls.forEach(function(priceEl) {
        priceEl.innerText = formatMoney(matchedVariant.price);
        priceEl.setAttribute("data-price", matchedVariant.price);
      });

    });

  }

  // Detect ANY change in page every 300ms
  setInterval(updateAssembly, 300);

});

// ---------------------------------pipe-product------------------------

document.addEventListener("DOMContentLoaded", function() {

  function updatePipes() {

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!variantInput) return;

    const variantJSON = document.querySelector('[data-variants-json]');
    if (!variantJSON) return;

    const mainVariants = JSON.parse(variantJSON.textContent);
    const mainVariant = mainVariants.find(v => v.id == variantInput.value);
    if (!mainVariant) return;

    const mainColor = mainVariant.option3 ? mainVariant.option3.trim() : null;
    if (!mainColor) return;

    const tierMatch = mainVariant.title.match(/\d+/);
    if (!tierMatch) return;
    const selectedTier = tierMatch[0];

    document.querySelectorAll(".wheels_pipes_addon--item").forEach(function(item) {

      const jsonScript = item.querySelector(".pipes-variants-json");
      if (!jsonScript) return;

      const variants = JSON.parse(jsonScript.textContent);

      const titleEl = item.querySelector(".pipe_var_title");
      if (!titleEl) return;

      let matchedVariant = variants.find(v => {

        const hasSameColor = v.option1 && v.option1.trim().toLowerCase() === mainColor.toLowerCase();
        const hasSameTier = new RegExp("\\b" + selectedTier + "\\b").test(v.title);

        return hasSameColor && hasSameTier;
      });

      if (!matchedVariant) {
        matchedVariant = variants.find(v =>
          new RegExp("\\b" + selectedTier + "\\b").test(v.title)
        );
      }

      if (!matchedVariant) return;

      item.setAttribute("data-id", matchedVariant.id);

      titleEl.innerText = matchedVariant.title;

      const priceEl = item.querySelector(".pipes--item-price");
      if (priceEl) {
        priceEl.innerText = "$" + (matchedVariant.price / 100).toFixed(2);
        priceEl.setAttribute("data-price", matchedVariant.price);
      }

    });

  }


  let currentVariantId = null;

  setInterval(function() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input) return;

    if (input.value !== currentVariantId) {
      currentVariantId = input.value;
      updatePipes();
    }
  }, 200);

});


